import type { ChatToken } from "schemas/generated/chatMessage";

import * as React from "react";

import { exhaustiveSwitch } from "replo-utils/lib/misc";

import { AssetToken } from "./chat-tokens/AssetToken";
import { ProductToken } from "./chat-tokens/ProductToken";

export default function ChatTokenComponent({ token }: { token: ChatToken }) {
  return exhaustiveSwitch(token)({
    product: ({ data }) => <ProductToken data={data} />,
    asset: ({ data }) => <AssetToken data={data} />,
    // Note (Noah, 2025-09-19): Currently we don't support adding a selected element
    // token directly inline in chat, so this is null
    "selected-element": () => null,
  });
}
